import {
	CurrencyType,
	DiscountRoomConditionType,
	DiscountType,
	SaleTypeForPlan,
	SaleTypeForTerm,
} from "@/lib/gql/__generated__/graphql";

import type * as DiscountItemOrdinaryShared from "../../../../../_shared";
import type * as QueryRepository from "../../../repository/query";

export const serverModelToInputModelConverter = (
	hotelID: string,
	serverModel?: QueryRepository.DiscountLongTermForLongTermStayServerModel,
): DiscountItemOrdinaryShared.Model.ModelType.DiscountLongTermStayFormModel["InputModel"] => {
	const defaultLongTermStayDiscountObject = [
		{
			includeSmallestNights: 1,
			discountType: DiscountType.Ratio,
			ratio: 5,
		},
	];

	if (!serverModel?.discountLongTerm) {
		return {
			hotelID,
			discountID: "",
			// 基本設定
			// 公開・非公開
			inSale: false,
			// ディスカウントの名前
			name: "",
			// ディスカウントの説明
			description: "",
			// ディスカウントのコード
			discountCode: "",
			// 最低提供価格
			resourceLowestPrice: {
				amount: 1000,
				currencyType: CurrencyType.Jpy,
			},
			longTermStayDiscountObject: defaultLongTermStayDiscountObject,

			// 追加設定
			// キャンセル不可にするか
			isUncancelable: false,
			// 販売タイプ
			saleTypeForPlan: SaleTypeForPlan.Limited,
			// 利用可能期間
			saleTypeForTerm: SaleTypeForTerm.Always,
			// 部屋の適用条件
			roomConditionType: DiscountRoomConditionType.AnyRoom,
		} as DiscountItemOrdinaryShared.Model.ModelType.DiscountLongTermStayFormModel["InputModel"];
	}

	const discountLongTerm = serverModel.discountLongTerm;
	return {
		...discountLongTerm,
		longTermStayDiscountObject:
			discountLongTerm.longTermStayDiscountObject.length > 0
				? discountLongTerm.longTermStayDiscountObject
				: defaultLongTermStayDiscountObject,
	} as DiscountItemOrdinaryShared.Model.ModelType.DiscountLongTermStayFormModel["InputModel"];
};
